/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TumDetailsBreakdown,
  TumDetailsBreakdown$inboundSchema,
} from "./tumdetailsbreakdown.js";
import {
  TumDetailsPoint,
  TumDetailsPoint$inboundSchema,
} from "./tumdetailspoint.js";
import {
  TumDetailsTotals,
  TumDetailsTotals$inboundSchema,
} from "./tumdetailstotals.js";

/**
 * Result of the billing usage details query. Everything derives from the tokens-under-management population — observed agent traffic with cache reads excluded — computed live from the telemetry aggregate. Matches the billed totals for cycles billed under this definition; cycles finalized before the observed-traffic redefinition serve immutable snapshot totals on the usage endpoint that can differ from this live compute.
 */
export type TumDetailsResult = {
  /**
   * Billed token usage per breakdown dimension
   */
  breakdowns: Array<TumDetailsBreakdown>;
  /**
   * Timeseries bucket width in seconds. Always 86400 — the details are bucketed daily.
   */
  intervalSeconds: number;
  /**
   * Gap-filled daily buckets in ascending time order
   */
  points: Array<TumDetailsPoint>;
  /**
   * Whole-range totals for the billing usage details
   */
  totals: TumDetailsTotals;
};

/** @internal */
export const TumDetailsResult$inboundSchema: z.ZodMiniType<
  TumDetailsResult,
  unknown
> = z.pipe(
  z.object({
    breakdowns: z.array(TumDetailsBreakdown$inboundSchema),
    interval_seconds: z.int(),
    points: z.array(TumDetailsPoint$inboundSchema),
    totals: TumDetailsTotals$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "interval_seconds": "intervalSeconds",
    });
  }),
);

export function tumDetailsResultFromJSON(
  jsonString: string,
): SafeParseResult<TumDetailsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TumDetailsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TumDetailsResult' from JSON`,
  );
}
